<template>
    <a-card :bordered="false" class="bl-card" :style="selectedOfferKeys.length && { marginBottom: '60px' }">
        <div class="bl-filterbar">
            <a-input
                class="bl-search-input"
                placeholder="Buscar por fornecedor ou vendedor"
                v-model="search"
                allow-clear
            />
        </div>
        <a-table
            size="small"
            :columns="columns"
            :data-source="filteredProviders"
            row-key="key"
            :loading="products_loading"
            :expandedRowKeys="expandedKeys"
            :expand-icon-column-index="1"
            :pagination="pagination"
            :locale="{ emptyText: 'Nenhum pré-pedido pendente.' }"
            @expand="onExpand"
        >
            <template slot="selecionarHeader">
                <a-checkbox
                    :checked="isAllFullySelected()"
                    :indeterminate="isAllPartiallySelected()"
                    @change="toggleAllSelection($event.target.checked)"
                />
            </template>

            <template slot="selecionar" slot-scope="text, provider">
                <a-checkbox
                    :checked="isProviderFullySelected(provider)"
                    :indeterminate="isProviderPartiallySelected(provider)"
                    @change="toggleProviderSelection(provider, $event.target.checked)"
                />
            </template>

            <template slot="fornecedor" slot-scope="text, provider">
                <div class="bf-sup">
                    <span class="bf-n">
                        {{ provider.nomeFornecedor }}<template v-if="provider.cnpj"> · {{ provider.cnpj }}</template>
                    </span>

                    <span class="bf-v" v-if="provider.nomeVendedor">
                        {{ provider.nomeVendedor }}
                    </span>
                </div>
            </template>

            <template slot="condPagamento" slot-scope="text, provider">
                {{ provider.paymentCondition || "—" }}
            </template>

            <template slot="entregaPrevista" slot-scope="text, provider">
                {{ provider.expectedDate ? $options.filters.formatDateOnly(provider.expectedDate) : "—" }}
            </template>

            <template slot="tipoEntrega" slot-scope="text, provider">
                {{ provider.deliveryType || "—" }}
            </template>

            <template slot="valor" slot-scope="text, provider">
                {{ total_provider(provider) | currency }}
            </template>

            <template slot="produtos" slot-scope="text, provider">
                {{ provider.products.length }}
            </template>

            <template slot="economia" slot-scope="text, provider">
                <span :class="economyClass(economy_provider(provider))">
                    {{ economy_provider(provider) | currency }}
                </span>
            </template>

            <template slot="faturamentoMinimo" slot-scope="text, provider">
                <span v-if="provider.minimumBilling">{{ provider.minimumBilling | currency }}</span>
                <span v-else>—</span>
            </template>

            <template slot="acoes" slot-scope="text, provider">
                <ActionMenu :actions="providerActions(provider)" />
            </template>

            <template slot="expandedRowRender" slot-scope="provider">
                <div class="expanded-table-wrapper">
                    <cc-loader-full v-if="expandingKeys[provider.key]" />
                    <a-table
                        v-else
                        :columns="getColumns()"
                        :data-source="provider.products"
                        row-key="id"
                        size="small"
                        :pagination="false"
                        :scroll="{ x: getTableWidth() }"
                        class="products-table"

                    >
                        <template slot="selecionar" slot-scope="text, product">
                            <a-checkbox
                                :checked="isProductFullySelected(product)"
                                :indeterminate="isProductPartiallySelected(product)"
                                @change="toggleProductSelection(product, $event.target.checked)"
                            />
                        </template>

                        <template slot="produto" slot-scope="text, product">
                            <div class="pro-name">
                                {{ product.name }}

                                <span class="brand" v-if="product.brand">
                                    {{ product.brand }}
                                </span>

                                <a-tooltip v-if="product.observations">
                                    <template slot="title">
                                        {{ product.observations.toUpperCase() }}
                                    </template>

                                    <a-icon type="info-circle"/>
                                </a-tooltip>
                            </div>
                            <div class="pro-ean" v-if="product.ean || product.internal_code">
                                <template v-if="product.ean">EAN {{ product.ean }}</template>
                                <template v-if="product.ean && product.internal_code"> · </template>
                                <template v-if="product.internal_code">Cód. {{ product.internal_code }}</template>
                            </div>
                            <span class="repl-tag" v-if="compact && replenishment(product)">
                                {{ replenishment(product) }}
                            </span>
                        </template>

                        <template slot="ressuprimento" slot-scope="text, product">
                            <span class="repl-tag" v-if="replenishment(product)">
                                {{ replenishment(product) }}
                            </span>
                            <span v-else>--</span>
                        </template>

                        <template slot="offer_price" slot-scope="text, product">
                            {{ product.offer_price | currency }}
                        </template>

                        <template slot="last_purchase" slot-scope="text, product">
                            {{ product.last_purchase | currency }}
                        </template>

                        <template slot="diferenca" slot-scope="text, product">
                            <span v-if="product.last_purchase" :class="deltaClass(product)">
                                {{ (product.offer_price - product.last_purchase) | currency }}
                            </span>
                            <span v-else>—</span>
                        </template>

                        <template slot="variacao" slot-scope="text, product">
                            <span v-if="product.last_purchase" :class="deltaClass(product)">
                                {{ variation(product).toFixed(1) }}%
                            </span>
                            <span v-else>—</span>
                        </template>

                        <template slot="requisicao" slot-scope="text, product">
                            {{ requisicao_sum(product.stores) }}
                        </template>

                        <template slot="embalagem" slot-scope="text, product">
                            {{ packingLabel(product) }}
                        </template>

                        <template slot="preco" slot-scope="text, product">
                            <div class="col-stack">
                                <span class="col-main">{{ product.offer_price | currency }}</span>
                                <template v-if="product.last_purchase">
                                    <span class="col-sub">Últ. {{ product.last_purchase | currency }}</span>
                                    <span class="col-sub" :class="deltaClass(product)">
                                        {{ product.offer_price > product.last_purchase ? "+" : "" }}{{ (product.offer_price - product.last_purchase) | currency }}
                                        · {{ variation(product).toFixed(1) }}%
                                    </span>
                                </template>
                                <span class="col-sub" v-else>Últ. —</span>
                            </div>
                        </template>

                        <template slot="quantidade" slot-scope="text, product">
                            {{ quantity_sum(product.stores) }}
                        </template>

                        <template slot="qtdResumo" slot-scope="text, product">
                            <div class="qty-labeled">
                                <span class="qty-label">Qtd</span>
                                <span class="col-main">{{ quantity_sum(product.stores) }}</span>
                                <span class="qty-label">Req.</span>
                                <span>{{ requisicao_sum(product.stores) }}</span>
                            </div>
                        </template>


                        <template slot="total" slot-scope="text, product">
                            {{ total(product.stores) | currency }}
                        </template>

                        <template slot="acoes" slot-scope="record">
                            <ActionMenu :actions="productActions(record, provider)" />
                        </template>


                        <template
                            v-for="store in stores"
                            :slot="'store_' + store.id + '_header'"
                        >
                            <a-tooltip :title="store.name" placement="top">
                                <span class="store-header-name">{{ store.name }}</span>
                            </a-tooltip>
                            <div class="store-header-total" :class="storeTotalClass(provider, store.id)">{{ storeTotal(provider, store.id) | currency }}</div>
                        </template>

                        <template
                            v-for="store in stores"
                            :slot="'store_' + store.id"
                            slot-scope="text, product"
                        >
                            <div class="matrix-store-cell" v-if="isCrossAtCd(product, store.id)">
                                <input
                                    type="text"
                                    class="matrix-qty-input ant-input"
                                    :value="quantity_sum(product.stores)"
                                    disabled
                                />
                            </div>
                            <div class="matrix-store-cell" v-else>
                                <span class="matrix-qty-wrap" :class="{ saved: !!savedCells[cellKey(filter_product(product, store.id))] }">
                                    <input
                                        v-if="isActiveCell(provider, product, store.id)"
                                        ref="activeInput"
                                        type="text"
                                        data-field="matrix-qty"
                                        class="matrix-qty-input ant-input"
                                        v-model="activeValue"
                                        @input="handleMatrixQuantityInput($event, product, store.id)"
                                        @blur="commitActiveCell(product, store.id)"
                                        @keydown="handleMatrixKeydown($event, product, store, provider)"
                                    />
                                    <input
                                        v-else-if="isOrderedCell(product, store.id)"
                                        type="text"
                                        class="matrix-qty-input ant-input"
                                        :value="orderedQuantity(product, store.id)"
                                        title="Pedido já gerado para esta loja com este fornecedor"
                                        disabled
                                    />
                                    <input
                                        v-else-if="isDepositAtNonCd(product, store.id)"
                                        type="text"
                                        class="matrix-qty-input ant-input"
                                        :value="displayQuantity(product, store.id)"
                                        disabled
                                    />
                                    <span
                                        v-else
                                        class="matrix-qty-input ant-input matrix-qty-display"
                                        @click="activateCell(product, store, provider)"
                                    >{{ displayQuantity(product, store.id) }}</span>
                                </span>
                                <div
                                    class="matrix-suggested"
                                    v-if="real_offer(product, store.id).request_quantity"
                                >
                                    Requisitado: {{ real_offer(product, store.id).request_quantity }}
                                </div>
                                <div
                                    class="matrix-suggested"
                                    v-if="real_offer(product, store.id).inventory != null"
                                >
                                    Estoque: {{ real_offer(product, store.id).inventory | stock }}
                                </div>
                            </div>
                        </template>

                    </a-table>
                </div>

            </template>
        </a-table>

        <NegotiationModal
            v-if="negotiationModal.open"
            :product="negotiationModal.product"
            :typing="negotiationModal.winner"
            :quotation_id="$route.params.id"
            @close="closeNegotiation"
        />

        <ProductWrapModal
            v-if="wrapModal.open"
            :product="wrapModal.product"
            :salesman="wrapModal.winner"
            @close="closeWrap"
        />

        <ChangeWinnerModal
            v-if="changeWinnerModal.open"
            :product="changeWinnerModal.product"
            :pre-orders="products"
            :quotation-id="$route.params.id"
            @close="closeChangeWinner"
            @saved="onWinnerChanged"
        />

        <TypedProductsModal
            v-if="typedProductsModal.open"
            :quotation-id="$route.params.id"
            :provider-id="typedProductsModal.providerId"
            :provider-name="typedProductsModal.providerName"
            :seller-id="typedProductsModal.sellerId"
            :seller-name="typedProductsModal.sellerName"
            @close="closeTypedProducts"
            @reload="$emit('reload')"
        />

        <ProviderMatrixModal
            :visible="providerMatrixModal.open"
            :provider="providerMatrixModalProvider"
            :stores="stores"
            :selected-offer-keys="selectedOfferKeys"
            :saved-cells="savedCells"
            :ordered-cells="orderedCells"
            :ordered-offers="orderedOffers"
            :has-navigation="filteredProviders.length > 1"
            :can-go-previous="canGoPreviousProviderMatrix"
            :can-go-next="canGoNextProviderMatrix"
            :current-index="providerMatrixModal.index"
            :total-count="filteredProviders.length"
            @close="closeProviderMatrix"
            @previous-provider="goToPreviousProviderMatrix"
            @next-provider="goToNextProviderMatrix"
            @update:selectedOfferKeys="setSelection"
            @cell-focus="(...args) => $emit('cell-focus', ...args)"
            @quantity-edited="(payload) => $emit('quantity-edited', payload)"
            @save-quantity="(payload) => $emit('save-quantity', payload)"
            @giro="(record, siblings) => $emit('giro', record, siblings)"
            @negotiate="openNegotiation"
            @wrap="openWrap"
            @change-winner="openChangeWinner"
        />

        <ProductOrdersModal
            v-if="historyModal.open"
            :product_id="historyModal.productId"
            :product_name="historyModal.productName"
            @close="historyModal.open = false"
        />

        <SellerPreOrderModal
            v-if="sellerPreOrderModal.open"
            :provider="sellerPreOrderModal.provider"
            :stores="stores"
            :quotation-id="$route.params.id"
            :generating="generating"
            @close="closeSellerPreOrder"
            @reload="$emit('reload')"
            @generate-orders="(keys) => $emit('generate-orders', keys)"
        />

        <AddProductPickerModal
            v-if="addProductModal.open"
            :quotation-id="$route.params.id"
            :provider-name="addProductModal.provider.nomeFornecedor"
            :seller-name="addProductModal.provider.nomeVendedor"
            :exclude-ids="addProductModal.provider.products.flatMap((p) => [p.id, p.main_product_id]).filter(Boolean)"
            @close="closeAddProduct"
            @select="openDistributionForNewProduct"
        />

        <StoreQuantityModal
            v-if="distributionModal.open"
            :winner="distributionModal.winner"
            :product="distributionModal.product"
            :quotation-id="$route.params.id"
            :mark-winner-on-save="distributionModal.markWinnerOnSave"
            @close="closeDistribution"
            @saved="onDistributionSaved"
            @price-updated="$emit('reload')"
        />

        <SelectionFooter
            :count="selectedOffers.length"
            item-label="ofertas selecionadas"
        >
            <template slot="summary">
                <strong>{{ selectedTotal | currency }}</strong>
            </template>

            <template slot="actions">
                <a-button size="large" @click="setSelection([])">Limpar seleção</a-button>
                <a-button size="large" @click="bulkExport">Exportar</a-button>
                <a-button size="large" @click="bulkZeroQuantity">Zerar quantidade</a-button>
                <a-button size="large" :loading="refreshingErp" :disabled="refreshingErp || generating" @click="$emit('refresh-erp', selectedOfferKeys)">Atualizar estoque/custo</a-button>
                <a-button size="large" type="primary" :disabled="generating" @click="bulkGenerateOrder">Gerar pedido</a-button>
            </template>
        </SelectionFooter>
    </a-card>
</template>

<script>
import QuotationService from "@/services/QuotationService";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import currencyPrecision from "@/mixins/currencyPrecision";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { replenishmentStrategyMixin } from "@/mixins/replenishment-strategy.mixin";
import { replenishmentLabel } from "@/helpers/replenishment";
import NegotiationModal from "@/modals/negotiate-offer/negotiate-offer.modal.vue";
import ProductWrapModal from "@/modals/product-wrap/product-wrap.modal.vue";
import ChangeWinnerModal from "@/modals/change-winner/change-winner.modal.vue";
import ProductOrdersModal from "@/modals/products/orders";
import TypedProductsModal from "./_typed-products.modal.vue";
import ProviderMatrixModal from "./_provider-matrix.modal.vue";
import SellerPreOrderModal from "./_seller-pre-order.modal.vue";
import StoreQuantityModal from "../comparativo/_store-quantity.modal.vue";
import AddProductPickerModal from "./_add-product-picker.modal.vue";
import ActionMenu from "@/components/popovers/action-menu.popover.vue";
import SelectionFooter from "@/components/cliente/monitors/SelectionFooter.vue";

const CROSS_STRATEGY = "CROSS";
const DEPOSIT_STRATEGY = "DEPOSIT";

const PRICE_LOCKED_TOOLTIP = "Pedido já gerado com este fornecedor — preço travado";

export default {
    name: "MatrixTable",
    mixins: [currencyPrecision, loaderMixin, replenishmentStrategyMixin],
    components: { NegotiationModal, ProductWrapModal, ChangeWinnerModal, ProductOrdersModal, TypedProductsModal, ProviderMatrixModal, SellerPreOrderModal, StoreQuantityModal, AddProductPickerModal, ActionMenu, SelectionFooter },
    props: {
        compact: {
            type: Boolean,
            default: false,
        },
        orderedCells: {
            type: Object,
            default: () => ({}),
        },
        orderedOffers: {
            type: Object,
            default: () => ({}),
        },
        // Fetched once by the parent (_pre-orders.tab.vue) and shared with
        // Por Produto/Analítico/Por loja (nova API) — same pre_orders_report()
        // call for all four, see [[winners-v2-backlog-triage]].
        products: {
            type: Array,
            default: () => [],
        },
        products_loading: {
            type: Boolean,
            default: false,
        },
        // Another generate-orders call (from this view or a sibling one) is
        // still in flight — blocks new ones so an early reload can't run
        // while a later request is still writing [[pre-orders-generate-race]].
        generating: {
            type: Boolean,
            default: false,
        },
        refreshingErp: {
            type: Boolean,
            default: false,
        },
        pendencyOnly: {
            type: Boolean,
            default: false,
        },
        // Shared with Por Loja (nova API) / Por Produto / Analítico via
        // `.sync` on the parent (_pre-orders.tab.vue) — same row-key shape
        // (`${produto}-${loja}-${fornecedor}-${vendedor}`). Matriz selects at
        // fornecedor/produto grain (cascading to every loja cell with
        // quantity > 0) instead of exposing a leaf-level loja checkbox, since
        // lojas are columns here, not rows — but the underlying keys are the
        // same offers, so a selection here still shows up in the other views.
        selectedOfferKeys: {
            type: Array,
            default: () => [],
        },
        savedCells: {
            type: Object,
            default: () => ({}),
        },
        // Typed-but-not-yet-fetched quantities owned by the parent — used
        // when padding lojas that have no row yet, so a reload doesn't zero a
        // cell whose save is still in flight.
        pendingQuantities: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            expandedKeys: [],
            expandingKeys: {},
            providers: [],
            stores: [],
            activeCell: null,
            activeValue: '',
            pagination: {
                pageSize: 50,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                locale: {
                    items_per_page: '/ página',
                },
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
            },
            productsCache: {},
            loadingProducts: {},
            svc: new QuotationService(),
            expanded: [],
            sending: {},
            search: "",
            negotiationModal: {
                open: false,
                winner: null,
                product: null,
            },
            wrapModal: {
                open: false,
                winner: null,
                product: null,
            },
            changeWinnerModal: {
                open: false,
                product: null,
            },
            historyModal: {
                open: false,
                productId: null,
                productName: "",
            },
            typedProductsModal: {
                open: false,
                providerId: null,
                providerName: "",
                sellerId: null,
                sellerName: "",
            },
            providerMatrixModal: {
                open: false,
                index: -1,
            },
            sellerPreOrderModal: {
                open: false,
                provider: null,
            },
            addProductModal: {
                open: false,
                provider: null,
            },
            distributionModal: {
                open: false,
                winner: null,
                product: null,
                markWinnerOnSave: false,
            },
        };
    },
    computed: {
        cdStoreId() {
            const cd = this.stores.find((s) => s.is_cd);
            return cd ? cd.id : null;
        },
        columns() {
            return [
                { title: "", key: "selecionar", width: 40, align: "center", slots: { title: "selecionarHeader" }, scopedSlots: { customRender: "selecionar" } },
                { title: "Fornecedor", key: "fornecedor", scopedSlots: { customRender: "fornecedor" } },
                { title: "Cond. Pgto.", key: "condPagamento", scopedSlots: { customRender: "condPagamento" } },
                { title: "Entrega prevista", key: "entregaPrevista", scopedSlots: { customRender: "entregaPrevista" } },
                { title: "Tipo de entrega", key: "tipoEntrega", scopedSlots: { customRender: "tipoEntrega" } },
                { title: "Produtos", key: "produtos", align: "right", scopedSlots: { customRender: "produtos" } },
                { title: "Fat. mín.", key: "faturamentoMinimo", align: "right", scopedSlots: { customRender: "faturamentoMinimo" } },
                { title: "Valor total", key: "valor", align: "right", scopedSlots: { customRender: "valor" } },
                { title: "Economia", key: "economia", align: "right", scopedSlots: { customRender: "economia" } },
                { title: "Ações", key: "acoes", width: 60, scopedSlots: { customRender: "acoes" } },
            ];
        },
        filteredProviders() {
            const term = (this.search || "").trim().toLowerCase();

            return this.providers.filter((provider) => {
                if (
                    term &&
                    !(provider.nomeFornecedor || "").toLowerCase().includes(term) &&
                    !(provider.nomeVendedor || "").toLowerCase().includes(term)
                ) {
                    return false;
                }

                if (
                    this.pendencyOnly &&
                    !(provider.minimumBilling && this.total_provider(provider) < provider.minimumBilling)
                ) {
                    return false;
                }

                return true;
            });
        },
        selectedOffers() {
            const keys = new Set(this.selectedOfferKeys);
            const offers = [];

            this.providers.forEach((provider) => {
                provider.products.forEach((product) => {
                    product.stores.forEach((store) => {
                        if (keys.has(this.cellKey(store))) offers.push(store);
                    });
                });
            });

            return offers;
        },
        selectedTotal() {
            return this.selectedOffers.reduce((sum, store) => sum + this.total([store]), 0);
        },
        providerMatrixModalProvider() {
            return this.providerMatrixModal.index >= 0
                ? this.filteredProviders[this.providerMatrixModal.index]
                : null;
        },
        canGoPreviousProviderMatrix() {
            return this.providerMatrixModal.index > 0;
        },
        canGoNextProviderMatrix() {
            return this.providerMatrixModal.index < this.filteredProviders.length - 1;
        },
    },
    methods: {
        isPriceLocked(productId, sellerId) {
            return !!this.orderedOffers[`${productId}-${sellerId}`];
        },
        isActiveCell(provider, product, storeId) {
            return !!this.activeCell &&
                this.activeCell.providerKey === provider.key &&
                this.activeCell.productId === product.id &&
                this.activeCell.storeId === storeId
        },
        displayQuantity(product, storeId) {
            return this.filter_product(product, storeId).requested_quantity || 0
        },
        activateCell(product, store, provider) {
            if (this.isCrossAtCd(product, store.id)) return
            if (this.isDepositAtNonCd(product, store.id)) return
            if (this.isOrderedCell(product, store.id)) return

            const current = this.filter_product(product, store.id)

            this.activeValue = String(current.requested_quantity || '')
            this.activeCell = { providerKey: provider.key, productId: product.id, storeId: store.id }

            this.$emit('cell-focus', product, store.position, provider ? provider.products : null)

            this.$nextTick(() => {
                const refs = this.$refs.activeInput
                const el = Array.isArray(refs) ? refs[0] : refs

                if (el) {
                    el.focus()
                    el.select()
                }
            })
        },
        commitActiveCell(product, storeId) {
            this.saveQuantity(product, storeId)

            if (this.activeCell && this.activeCell.productId === product.id && this.activeCell.storeId === storeId) {
                this.activeCell = null
            }
        },
        saveQuantity(product, storeId) {
            const store = product.stores.find(
                s => s.store_id == storeId
            )

            if (!store) return

            this.$emit('save-quantity', {
                key: this.cellKey(store),
                product_id: product.id,
                store_id: store.store_id,
                seller_id: product.seller_id,
            })
        },
        replenishment(product) {
            return replenishmentLabel(product.replenishment_strategy)
        },
        deltaClass(product) {
            if (product.offer_price > product.last_purchase) return "vpm-up"
            if (product.offer_price < product.last_purchase) return "vpm-down"
            return ""
        },
        variation(product) {
            if (!product.last_purchase) return 0
            return ((product.offer_price - product.last_purchase) / product.last_purchase) * 100
        },
        packingLabel(product) {
            if (product.purchase_unity) return product.purchase_unity
            if (!product.packing) return ""

            const [unit, amount] = product.packing.split(" ")

            return [unit, amount].filter(Boolean).join(" ")
        },
        getTableWidth() {
            const fixedWidth = this.fixedColumns().reduce((sum, column) => sum + column.width, 0)

            return fixedWidth + (this.stores.length * 80)
        },
        replaceStore(product, storeId, changes) {
            const index = product.stores.findIndex(s => s.store_id == storeId)

            if (index === -1) return null

            const updated = Object.freeze({ ...product.stores[index], ...changes })

            product.stores.splice(index, 1, updated)

            return updated
        },
        handleMatrixQuantityInput(event, product, storeId) {
            let value = event.target.value.replace(/\D/g, '')

            const store = this.filter_product(product, storeId)

            if (!store.store_id) {
                return
            }

            value = value.replace(/^0+(?=\d)/, '')

            if (+value > 999999) {
                value = '999999'
            }

            this.activeValue = value
            event.target.value = value

            const updated = this.replaceStore(product, storeId, { requested_quantity: value })

            if (updated) {
                this.$emit('quantity-edited', { key: this.cellKey(updated), requested_quantity: value });
            }
        },
        handleMatrixKeydown(event, product, store, provider) {
            if (
                ![
                    'Enter',
                    'ArrowDown',
                    'ArrowUp',
                    'ArrowLeft',
                    'ArrowRight'
                ].includes(event.key)
            ) {
                return
            }

            event.preventDefault()

            const rowIndex = provider.products.indexOf(product)
            const colIndex = this.stores.findIndex(s => s.id == store.id)

            if (rowIndex === -1 || colIndex === -1) {
                return
            }

            let nextRow = rowIndex
            let nextCol = colIndex

            switch (event.key) {
                case 'Enter':
                case 'ArrowDown':
                    nextRow = rowIndex + 1
                    break

                case 'ArrowUp':
                    nextRow = rowIndex - 1
                    break

                case 'ArrowRight':
                    nextCol = colIndex + 1
                    break

                case 'ArrowLeft':
                    nextCol = colIndex - 1
                    break
            }

            nextRow = Math.max(0, Math.min(nextRow, provider.products.length - 1))
            nextCol = Math.max(0, Math.min(nextCol, this.stores.length - 1))

            const nextProduct = provider.products[nextRow]
            const nextStore = this.stores[nextCol]

            if (nextProduct && nextStore) {
                this.activateCell(nextProduct, nextStore, provider)
            }
        },
        onExpand(expanded, record) {

            const index = this.expandedKeys.indexOf(record.key);

            if (expanded) {

                if (index === -1) {
                    this.$set(this.expandingKeys, record.key, true);
                    this.expandedKeys.push(record.key);

                    this.$nextTick(() => {
                        requestAnimationFrame(() => {
                            this.$delete(this.expandingKeys, record.key);
                        });
                    });
                }

            } else {

                if (index !== -1) {
                    this.expandedKeys.splice(index, 1);
                }

                this.$delete(this.expandingKeys, record.key);
            }
        },
        total_provider(provider) {
            let result = 0;
            provider.products.forEach(p => {
                result += this.total(p.stores)
            })
            return result
        },
        economy(stores) {
            return stores.reduce((sum, store) => {
                const lastPurchase = Number(store.last_purchase) || 0

                if (lastPurchase <= 0) return sum

                const units = store.is_generic == 0 && store.main_product_id == null
                    ? parseInt((store.packing || '').split(' ')[1]) || 1
                    : 1

                return sum + (lastPurchase - store.offer_price) * units * (store.requested_quantity || 0)
            }, 0)
        },
        economy_provider(provider) {
            return provider.products.reduce((sum, p) => sum + this.economy(p.stores), 0)
        },
        economyClass(value) {
            if (value > 0) return "vpm-down"
            if (value < 0) return "vpm-up"
            return ""
        },
        cellKey(store) {
            return `${store.id}-${store.store_id}-${store.provider_id}-${store.seller_id}`;
        },
        setSelection(keys) {
            this.$emit('update:selectedOfferKeys', keys);
        },
        // "Select all" (whichever level) only ever ADDS cells with a
        // quantity typed in — there is nothing to gerar pedido/zerar for an
        // untouched (qty 0) cell. Unselecting still clears everything.
        selectableKeys(stores) {
            return stores.filter((store) => Number(store.requested_quantity) > 0).map((store) => this.cellKey(store));
        },
        isProductFullySelected(product) {
            const keys = this.selectableKeys(product.stores);
            return keys.length > 0 && keys.every((key) => this.selectedOfferKeys.includes(key));
        },
        isProductPartiallySelected(product) {
            const keys = this.selectableKeys(product.stores);
            const selectedCount = keys.filter((key) => this.selectedOfferKeys.includes(key)).length;
            return selectedCount > 0 && selectedCount < keys.length;
        },
        toggleProductSelection(product, checked) {
            if (checked) {
                const keys = this.selectableKeys(product.stores);
                this.setSelection(Array.from(new Set([...this.selectedOfferKeys, ...keys])));
                return;
            }

            const allKeys = product.stores.map((store) => this.cellKey(store));
            this.setSelection(this.selectedOfferKeys.filter((key) => !allKeys.includes(key)));
        },
        isProviderFullySelected(provider) {
            const keys = this.selectableKeys(provider.products.flatMap((product) => product.stores));
            return keys.length > 0 && keys.every((key) => this.selectedOfferKeys.includes(key));
        },
        isProviderPartiallySelected(provider) {
            const keys = this.selectableKeys(provider.products.flatMap((product) => product.stores));
            const selectedCount = keys.filter((key) => this.selectedOfferKeys.includes(key)).length;
            return selectedCount > 0 && selectedCount < keys.length;
        },
        toggleProviderSelection(provider, checked) {
            const allStores = provider.products.flatMap((product) => product.stores);

            if (checked) {
                const keys = this.selectableKeys(allStores);
                this.setSelection(Array.from(new Set([...this.selectedOfferKeys, ...keys])));
                return;
            }

            const allKeys = allStores.map((store) => this.cellKey(store));
            this.setSelection(this.selectedOfferKeys.filter((key) => !allKeys.includes(key)));
        },
        isAllFullySelected() {
            const keys = this.selectableKeys(this.filteredProviders.flatMap((provider) => provider.products.flatMap((product) => product.stores)));
            return keys.length > 0 && keys.every((key) => this.selectedOfferKeys.includes(key));
        },
        isAllPartiallySelected() {
            const keys = this.selectableKeys(this.filteredProviders.flatMap((provider) => provider.products.flatMap((product) => product.stores)));
            const selectedCount = keys.filter((key) => this.selectedOfferKeys.includes(key)).length;
            return selectedCount > 0 && selectedCount < keys.length;
        },
        toggleAllSelection(checked) {
            const allStores = this.filteredProviders.flatMap((provider) => provider.products.flatMap((product) => product.stores));

            if (checked) {
                const keys = this.selectableKeys(allStores);
                this.setSelection(Array.from(new Set([...this.selectedOfferKeys, ...keys])));
                return;
            }

            const allKeys = allStores.map((store) => this.cellKey(store));
            this.setSelection(this.selectedOfferKeys.filter((key) => !allKeys.includes(key)));
        },
        bulkGenerateOrder() {
            if (!this.selectedOffers.length) return;

            this.confirm_action({
                message: `Gerar pedido para ${this.selectedOffers.length} oferta(s) selecionada(s)?`,
                confirm_text: "Gerar pedidos",
                callback: () => {
                    this.$emit('generate-orders', this.selectedOfferKeys);
                },
            });
        },
        bulkZeroQuantity() {
            if (!this.selectedOffers.length) return;

            this.confirm_action({
                message: `Zerar a quantidade de ${this.selectedOffers.length} oferta(s) selecionada(s)?`,
                confirm_text: "Zerar quantidade",
                callback: () => {
                    const keys = this.selectedOffers.map((store) => this.cellKey(store));

                    Promise.all(
                        this.selectedOffers.map((store) => {
                            const product = this.findProduct(store.id);
                            if (product) this.replaceStore(product, store.store_id, { requested_quantity: 0 });

                            return this.svc.sendQuantidade({
                                numerocotacao: this.$route.params.id,
                                quantidade: 0,
                                vendedor: store.seller_id,
                                produto: store.id,
                                loja: store.store_id,
                            });
                        })
                    )
                        .then(() => {
                            keys.forEach((key) => this.$emit('quantity-synced', { key, requested_quantity: 0 }));
                            this.snack("Quantidades zeradas com sucesso.");
                            this.setSelection([]);
                        })
                        .catch((error) => {
                            this.snack("Não foi possível zerar uma ou mais quantidades.", "error");
                            ErrorHandlerService.handle(error, this.$store);
                        });
                },
            });
        },
        bulkExport() {
            if (!this.selectedOffers.length) return;

            const headers = ["Produto", "Fornecedor", "Vendedor", "Loja", "Valor", "Quantidade", "Total"];

            const rows = this.selectedOffers.map((store) => {
                const storeEntity = this.stores.find((s) => s.id == store.store_id);

                return [
                    store.name,
                    store.provider_name,
                    store.seller_name || "",
                    storeEntity ? storeEntity.name : "",
                    store.offer_price,
                    store.requested_quantity || 0,
                    this.total([store]),
                ];
            });

            const csv = [headers, ...rows]
                .map((row) => row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(";"))
                .join("\n");

            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = `pre-pedidos-matriz-${this.$route.params.id}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            this.setSelection([]);
        },
        storesWithQuantity(provider) {
            const ids = new Set();
            provider.products.forEach((p) => {
                p.stores.forEach((s) => {
                    if (Number(s.requested_quantity) > 0) ids.add(s.store_id);
                });
            });
            return Array.from(ids);
        },
        generateOrder(provider) {
            const storeIds = this.storesWithQuantity(provider);

            if (!storeIds.length) {
                this.snack("Nenhuma quantidade informada para gerar pedido.", "error");
                return;
            }

            const keys = provider.products.flatMap((p) => this.selectableKeys(p.stores));

            this.confirm_action({
                message: `Gerar pedido para ${provider.nomeFornecedor} em ${storeIds.length} loja(s)?`,
                confirm_text: "Gerar pedido",
                callback: () => {
                    this.$set(this.sending, provider.key, true);
                    this.$emit('generate-orders', keys);
                },
            });
        },
        providerActions(provider) {
            return [
                { label: "Gerar pedido", icon: "local_shipping", iconClass: "action-primary", disabled: this.sending[provider.key] || this.generating, onClick: () => this.generateOrder(provider) },
                { label: "Ver pré-pedido do vendedor", icon: "shopping_cart", iconClass: "action-info", onClick: () => this.openSellerPreOrder(provider) },
                { label: "Ver produtos digitados", icon: "inventory_2", iconClass: "action-teal", onClick: () => this.openTypedProducts(provider) },
                { label: "Adicionar produto", icon: "add_box", iconClass: "action-success", onClick: () => this.openAddProduct(provider) },
                { label: "Ver em tela cheia", icon: "fullscreen", iconClass: "action-primary", onClick: () => this.openProviderMatrix(provider) },
            ];
        },
        openSellerPreOrder(provider) {
            this.sellerPreOrderModal = { open: true, provider };
        },
        closeSellerPreOrder() {
            this.sellerPreOrderModal.open = false;
        },
        openProviderMatrix(provider) {
            const index = this.filteredProviders.findIndex((p) => p.key == provider.key);
            if (index === -1) return;

            this.providerMatrixModal = { open: true, index };
            this.expandedKeys = [provider.key];
        },
        closeProviderMatrix() {
            this.providerMatrixModal.open = false;
        },
        goToPreviousProviderMatrix() {
            if (!this.canGoPreviousProviderMatrix) return;
            this.providerMatrixModal.index--;
            this.expandedKeys = [this.providerMatrixModalProvider.key];
        },
        goToNextProviderMatrix() {
            if (!this.canGoNextProviderMatrix) return;
            this.providerMatrixModal.index++;
            this.expandedKeys = [this.providerMatrixModalProvider.key];
        },
        openTypedProducts(provider) {
            this.typedProductsModal = {
                open: true,
                providerId: provider.provider_id,
                providerName: provider.nomeFornecedor,
                sellerId: provider.seller_id,
                sellerName: provider.nomeVendedor,
            };
        },
        closeTypedProducts() {
            this.typedProductsModal.open = false;
        },
        openAddProduct(provider) {
            this.addProductModal = { open: true, provider };
        },
        closeAddProduct() {
            this.addProductModal.open = false;
        },
        parsePackagingMultiplier(packing) {
            const value = parseInt(String(packing || "").split(" ")[1], 10);
            return Number.isFinite(value) && value > 0 ? value : 1;
        },
        openDistributionForNewProduct(product) {
            const provider = this.addProductModal.provider;
            const packagingMultiplier = this.parsePackagingMultiplier(product.pro_embalagem);

            this.addProductModal.open = false;

            this.$nextTick(() => {
                this.distributionModal = {
                    open: true,
                    winner: {
                        pro_id: product.pro_id,
                        idVendedor: provider.seller_id,
                        valor: 0,
                        nomeFornecedor: provider.nomeFornecedor,
                        nomeVendedor: provider.nomeVendedor,
                        embalagem: packagingMultiplier,
                    },
                    product: {
                        descricaoProduto: product.pro_descricao,
                        flag_generico: product.pro_generico,
                        qtd_embalagem: packagingMultiplier,
                        ean: product.pro_ean,
                        internal_code: product.pro_codInterno,
                    },
                    markWinnerOnSave: true,
                };
            });
        },
        closeDistribution() {
            this.distributionModal.open = false;
        },
        onDistributionSaved() {
            this.distributionModal.open = false;
            this.$emit('reload');
        },
        productActions(record, provider) {
            const priceLocked = this.isPriceLocked(record.id, record.seller_id);

            return [
                { label: "Análise de giro", icon: "query_stats", iconClass: "action-info", onClick: () => this.$emit("giro", record, provider.products) },
                { label: "Negociar preço", icon: "handshake", iconClass: "action-success", disabled: priceLocked, tooltip: priceLocked ? PRICE_LOCKED_TOOLTIP : null, onClick: () => this.openNegotiation(record) },
                { label: "Alterar embalagem", icon: "inventory_2", iconClass: "action-warning", onClick: () => this.openWrap(record) },
                { label: "Alterar vencedor", icon: "emoji_events", iconClass: "action-teal", onClick: () => this.openChangeWinner(record) },
                { label: "Histórico de pedidos", icon: "assignment", iconClass: "action-teal", onClick: () => this.openHistory(record) },
                { label: "Alterar tipo de reabastecimento", icon: "sync_alt", iconClass: "action-primary", disabled: this.savingReplenishment === record.id, onClick: () => this.promptReplenishmentStrategy(record) },
            ];
        },
        openHistory(product) {
            this.historyModal = {
                open: true,
                productId: Number(product.id),
                productName: product.name,
            };
        },
        openChangeWinner(record) {
            this.changeWinnerModal = {
                open: true,
                product: record,
            };
        },
        closeChangeWinner() {
            this.changeWinnerModal.open = false;
        },
        onWinnerChanged() {
            this.$emit('reload');
        },
        openNegotiation(record) {
            this.negotiationModal = {
                open: true,
                winner: {
                    idVendedor: record.seller_id,
                    idFornecedor: record.provider_id,
                    pro_id: record.id,
                    valor: record.offer_price,
                    nomeVendedor: record.seller_name,
                },
                product: {
                    produtoDescricao: record.name,
                    pro_observacao: record.brand,
                    observacao: record.observations,
                    ultimaCompra: record.last_purchase,
                },
            };
        },
        closeNegotiation() {
            this.negotiationModal.open = false;
            this.$emit('reload');
        },
        openWrap(record) {
            this.wrapModal = {
                open: true,
                winner: {
                    idVendedor: record.seller_id,
                    idFornecedor: record.provider_id,
                    pro_id: record.id,
                    embalagem: record.packing,
                },
                product: {
                    descricaoProduto: record.name,
                    embalagem: record.packing,
                    idProduto: record.id,
                    flag_generico: record.is_generic,
                    pro_principal: record.main_product_id,
                },
            };
        },
        closeWrap() {
            this.wrapModal.open = false;
            this.$emit('reload');
        },
        process_available_providers() {
            this.products.forEach(rawPp => {
                const pp = Object.freeze({ ...rawPp })
                let prov = this.providers.find(prov => prov.provider_id == pp.provider_id && pp.seller_id == prov.seller_id)
                if(prov) {
                    let pro = prov.products.find(pr => pr.id == pp.id)
                    if (pro) {
                        const index = pro.stores.findIndex(
                            s => s.store_id == pp.store_id
                        )

                        if (index === -1) {
                            pro.stores.push(pp)
                        } else {
                            pro.stores.splice(index, 1, pp)
                        }
                    } else {
                        prov.products.push({ ...pp, stores: [ pp ] })
                    }
                } else {
                    this.providers.push({
                        key: `${pp.provider_id}-${pp.seller_id}`,
                        provider_id: pp.provider_id,
                        seller_id: pp.seller_id,
                        nomeFornecedor: pp.provider_name,
                        nomeVendedor: pp.seller_name,
                        telefone: pp.seller_phone,
                        minimumBilling: pp.minimum_billing,
                        cnpj: pp.provider_cnpj,
                        paymentCondition: pp.payment_condition,
                        expectedDate: pp.expected_date,
                        deliveryType: pp.delivery_type,
                        stores: [pp],
                        products: [
                            {
                                ...pp,
                                stores: [pp]
                            }
                        ]
                    });
                }
            })
        },
        fixedColumns() {
            const column = (title, key, width, align = "center") => ({
                title,
                key,
                width,
                align,
                scopedSlots: { customRender: key },
            })

            const head = [
                column("", "selecionar", 36),
                column("Produto", "produto", this.compact ? 180 : 140, "left"),
            ]

            const tail = [
                column("Total", "total", 85),
                column("Ações", "acoes", 46, "left"),
            ]

            if (this.compact) {
                return [
                    ...head,
                    column("Preço", "preco", 140),
                    column("Qtd", "qtdResumo", 80),
                    column("Emb", "embalagem", 60),
                    ...tail,
                ]
            }

            return [
                ...head,
                column("Reabastecimento", "ressuprimento", 100),
                column("Valor", "offer_price", 65),
                column("Últ. Compra", "last_purchase", 70),
                column("Diferença", "diferenca", 80),
                column("Variação", "variacao", 70),
                column("Requisição", "requisicao", 70),
                column("Qtd", "quantidade", 50),
                column("Emb", "embalagem", 50),
                ...tail,
            ]
        },
        getColumns() {
            const storeColumns = this.stores.map(store => ({
                key: `store_${store.id}`,
                width: 80,
                align: "center",
                slots: {
                    title: `store_${store.id}_header`
                },
                scopedSlots: {
                    customRender: `store_${store.id}`
                }
            }))

            return [...this.fixedColumns(), ...storeColumns]
        },
        processProducts() {
            this.providers = [];
            this.process_available_providers();
            this.padProductStores();
            this.sortProviderProducts();
        },
        sortProviderProducts() {
            this.providers.forEach((provider) => {
                provider.products.sort((a, b) => (a.name || "").localeCompare(b.name || "", "pt-BR"));
            });
        },
        padProductStores() {
            if (!this.stores.length) return

            this.providers.forEach(provider => {
                provider.products.forEach(product => {
                    this.stores.forEach(store => {
                        // A central não compra CROSS, só distribui — não cria
                        // uma célula editável pra ela nesses produtos.
                        if (this.isCrossAtCd(product, store.id)) return

                        const exists = product.stores.some(s => s.store_id == store.id)

                        if (!exists) {
                            const baseStore = product.stores[0] || {}
                            const pending = this.pendingQuantities[this.cellKey({ ...baseStore, store_id: store.id })]

                            product.stores.push(Object.freeze({
                                ...baseStore,
                                store_id: store.id,
                                store_name: store.name,
                                inventory: null,
                                erp_last_purchase_price: null,
                                request_quantity: null,
                                suggested_quantity: null,
                                quantity: null,
                                total: null,
                                requested_quantity: pending ? pending.value : 0,
                                isNewStore: true
                            }))
                        }
                    })
                })
            })
        },
        isCrossAtCd(product, storeId) {
            return product.replenishment_strategy === CROSS_STRATEGY && this.cdStoreId != null && storeId == this.cdStoreId;
        },
        orderedCellKey(product, storeId) {
            return `${product.id}-${storeId}-${product.provider_id}-${product.seller_id}`
        },
        isOrderedCell(product, storeId) {
            return this.orderedCellKey(product, storeId) in this.orderedCells
        },
        orderedQuantity(product, storeId) {
            return this.orderedCells[this.orderedCellKey(product, storeId)]
        },
        isDepositAtNonCd(product, storeId) {
            return product.replenishment_strategy === DEPOSIT_STRATEGY && this.cdStoreId != null && storeId != this.cdStoreId;
        },
        sort_stores() {
            this.stores.sort((a, b) => {
				if (a.is_cd && !b.is_cd) return -1
				if (b.is_cd && !a.is_cd) return 1
				if (a.position > b.position) return 1
				if (b.position > a.position) return -1
				return 0
			})
        },
        async loadStores() {
            this.stores = await this.$store.dispatch('user/fetch_stores')
            this.sort_stores()
            this.padProductStores();
        },
        total(stores) {
            return stores.reduce((sum, store) => {
                return sum + (
                    (store.requested_quantity || 0)*
                    (store.is_generic == 0 && store.main_product_id == null ?
                        parseInt(store.packing.split(' ')[1])*store.offer_price : store.offer_price)
                    )
            }, 0)
        },
        storeTotalClass(provider, storeId) {
            const total = this.storeTotal(provider, storeId)

            if (!total) return null

            return total >= Number(provider.minimumBilling || 0) ? 'reached' : 'below'
        },
        storeTotal(provider, storeId) {
            return provider.products.reduce((sum, product) => {
                const quantity = this.isCrossAtCd(product, storeId)
                    ? this.quantity_sum(product.stores)
                    : (this.filter_product(product, storeId).requested_quantity || 0)

                const unitValue = product.is_generic == 0 && product.main_product_id == null
                    ? parseInt(product.packing.split(' ')[1]) * product.offer_price
                    : product.offer_price

                return sum + quantity * unitValue
            }, 0)
        },
        quantity_sum(stores) {

            return stores.reduce((sum, store) => {
                return sum + Number(store.requested_quantity || 0)
            }, 0)
        },
        requisicao_sum(stores) {
            const sum = stores.reduce((total, store) => total + Number(store.request_quantity || 0), 0)
            return sum || "—"
        },
        filter_product(product, store_id) {
            return (product.stores || []).find(
                s => s.store_id == store_id
            ) || {};
        },
        findProduct(productId) {
            for (const provider of this.providers) {
                const product = provider.products.find(p => p.id == productId)
                if (product) return product
            }

            return null
        },
        real_offer(product, store_id) {
            return (product.stores || []).find(
                s => s.store_id == store_id && !s.isNewStore
            ) || {};
        },
    },
    created() {
        this.loadStores();
    },
    watch: {
        products: {
            immediate: true,
            handler(value) {
                if (!value || !value.length) return;
                this.processProducts();
            }
        },
        products_loading(loading) {
            if (!loading) this.sending = {};
        },
    },

    
};
</script>

<style lang="scss" scoped>

.pro-ean {
    font-size: 11px;
    color: #8c8c8c;
}

::v-deep(.ant-table-expanded-row > td) {
    padding: 0 !important;
    max-width: 0;
}

::v-deep(.ant-table-expanded-row) {
    overflow: hidden;
}
::v-deep(.products-table .ant-table-content) {
    overflow-x: auto;
}
::v-deep(.products-table table) {
    table-layout: fixed;
}
::v-deep(.products-table .ant-table-thead > tr > th),
::v-deep(.products-table .ant-table-tbody > tr > td) {
    padding: 6px !important;
}
::v-deep(.products-table .ant-table-tbody > tr > td) {
    vertical-align: top !important;
}
.bl-card ::v-deep(.ant-table-thead > tr > th) {
    white-space: nowrap;
}
.store-header-name {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.store-header-total {
    font-size: 11px;
    font-weight: 400;
    color: #8c8c8c;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.store-header-total.reached {
    color: #389e0d;
    font-weight: 600;
}
.store-header-total.below {
    color: #cf1322;
    font-weight: 600;
}
.expanded-table-wrapper {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
}
.repl-tag {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 10px;
    background: #f0f0f0;
    color: #595959;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}
.pro-ean + .repl-tag,
.pro-name + .repl-tag {
    margin-top: 2px;
}
.col-stack {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.3;
}
.col-main {
    white-space: nowrap;
}
.col-sub {
    font-size: 1em;
    color: rgba(0, 0, 0, 0.45);
    white-space: nowrap;
}
.qty-labeled {
    display: inline-grid;
    grid-template-columns: auto auto;
    column-gap: 6px;
    font-size: 1.1em;
    line-height: 1.3;
    text-align: left;
    white-space: nowrap;
}
.qty-label {
    font-size: 0.9em;
    color: rgba(0, 0, 0, 0.45);
}
.bf-sup {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.bf-n {
    font-weight: 600;
    color: #262626;
}
.bf-v {
    font-size: 12px;
    color: #8c8c8c;
    font-style: italic;
}

.product-info {
    display: flex;
    gap: 12px;
    font-size: 12px;
    color: #666;
    margin-top: 4px;
}

.product-info span {
    white-space: nowrap;
}

.quantity-box {
    width: 45px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    margin: auto;

    border-radius: 6px;
    background: #f5f5f5;
    font-weight: 600;
}
.matrix-qty {
    width: 40px;
    height: 28px;

    margin: 0 auto;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid #d9d9d9;
    border-radius: 4px;

    background: #fafafa;

    font-size: 12px;
    font-weight: 600;
}
.matrix-qty-input {
    width: 48px;
    text-align: center;

    .ant-input {
        padding: 2px 4px;
    }
}
.matrix-store-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.matrix-qty-wrap {
    display: contents;
}
.matrix-qty-wrap.saved ::v-deep(.ant-input),
.matrix-qty-wrap.saved .matrix-qty-display {
    background-color: #13c7213d;
    color: green !important;
}
.matrix-qty-display {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: text;
}
.vpm-up {
    color: #cf1322;
    font-weight: 600;
}
.vpm-down {
    color: #389e0d;
    font-weight: 600;
}
.matrix-suggested {
    font-size: 11px;
    color: #8c8c8c;
    text-align: center;
    margin-top: 2px;
    white-space: nowrap;
}
.matrix-product {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.matrix-title {
    font-weight: 600;
    font-size: 14px;
}

.matrix-brand {
    margin-left: 6px;
    color: #999;
    font-size: 12px;
}

.matrix-info {
    display: flex;
    gap: 18px;
    flex-wrap: wrap;
}

.matrix-info span {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 60px;
}

.matrix-info small {
    color: #888;
    font-size: 11px;
}

.matrix-info b {
    margin-top: 2px;
    font-size: 13px;
}

.matrix-info .total-products {
    color: #20CE88;
}
.bl-card {
    --pri: var(--primary-color);
    width: 100%;

    ::v-deep(.ant-card-body) {
        width: 100%;
        padding: 0;
    }
    // ::v-deep(.ant-table-wrapper),
    // ::v-deep(.ant-table),
    // ::v-deep(.ant-table-content),
    // ::v-deep(table) {
        // width: 100%;
    // }
}
.bl-strong {
    font-weight: 600;
    color: #262626;
}
.bl-sup {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.bl-n {
    font-weight: 600;
    color: #262626;
}
.bl-v {
    font-size: 12px;
    color: #8c8c8c;
    font-style: italic;
}
.bl-below-min {
    color: #cf1322;
    font-weight: 600;
}
.bl-filterbar {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
}
.bl-search-input {
    flex: 1 1 160px;
    min-width: 140px;
    max-width: 260px;
}
</style>
